import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgInfoFilled16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4444 12.4445 16 8.00003 16C3.55559 16 3.05176e-05 12.4444 3.05176e-05 8C3.05176e-05 3.55556 3.55559 0 8.00003 0C12.4445 0 16 3.55556 16 8ZM8.01406 5.98034C7.7994 5.98034 7.62207 5.92901 7.48207 5.82634C7.34206 5.72367 7.27206 5.56034 7.27206 5.33634C7.27206 5.08434 7.34206 4.91634 7.48207 4.83234C7.62207 4.73901 7.7994 4.69234 8.01406 4.69234C8.20073 4.69234 8.36407 4.73901 8.50406 4.83234C8.6534 4.91634 8.72807 5.08434 8.72807 5.33634C8.72807 5.56967 8.6534 5.73767 8.50406 5.84034C8.36407 5.93367 8.20073 5.98034 8.01406 5.98034ZM7.32806 7.98434C7.32806 7.7082 7.55192 7.48434 7.82806 7.48434H8.17207C8.44821 7.48434 8.67207 7.7082 8.67207 7.98434V11.3077C8.67207 11.5838 8.44821 11.8077 8.17207 11.8077H7.82806C7.55192 11.8077 7.32806 11.5838 7.32806 11.3077L7.32806 7.98434Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoFilled16);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=InfoFilled16.svg.js.map
